import * as React from "react";

export default function ReceiptsFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v18l-2.5-1.5L15 22l-2.5-1.5L10 22l-2.5-1.5L5 22l-1-1V4Zm4 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Zm0 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Zm0 4a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H8Z" />
    </svg>
  );
}

